export const CONTACT = {
  name: "Tristan Todd",
  email: "tristan@behaviouroperatingsystem.com",
  linkedin: "https://www.linkedin.com/in/tristanltodd/",
  location: "Sydney, Australia",
};

export const SCALE = [
  { value: 1, label: "Not true in this area" },
  { value: 2, label: "Slightly true" },
  { value: 3, label: "Partly true" },
  { value: 4, label: "Mostly true" },
  { value: 5, label: "Consistently true" },
];

export const SECTIONS = [
  {
    key: "D",
    name: "Direction",
    intro: "Whether people understand the result the work exists to produce.",
    items: [
      { id: "D1", text: "People can explain the operational outcome this work is expected to produce." },
      { id: "D2", text: "When priorities compete, people understand what should take precedence." },
      { id: "D3", text: "Success is described in practical terms rather than activity alone." },
    ],
  },
  {
    key: "S",
    name: "Standards",
    intro: "Whether the requirements that define acceptable work are understood and applied consistently.",
    items: [
      { id: "S1", text: "People understand the requirements that define acceptable work." },
      { id: "S2", text: "Leaders apply the important quality, service, timing, and risk standards consistently." },
      { id: "S3", text: "People know where a standard is mandatory and where reasonable variation is permitted." },
    ],
  },
  {
    key: "O",
    name: "Ownership",
    intro: "Whether responsibility for outcomes, handovers and resolution is explicit.",
    items: [
      { id: "O1", text: "Responsibility for the final outcome is clear." },
      { id: "O2", text: "Handovers make it clear where one responsibility ends and another begins." },
      { id: "O3", text: "When work is incomplete or disputed, people know who must resolve it." },
    ],
  },
  {
    key: "A",
    name: "Authority",
    intro: "Whether people know what they can decide, and where escalation applies.",
    items: [
      { id: "A1", text: "People know which routine decisions they can make without approval." },
      { id: "A2", text: "Approval and escalation boundaries are clear and applied consistently." },
      { id: "A3", text: "People can exercise appropriate judgment when normal exceptions occur." },
    ],
  },
  {
    key: "B",
    name: "Behaviour",
    intro: "Whether expected behaviours are observable and consistently reinforced.",
    items: [
      { id: "B1", text: "The behaviours required for effective coordination are described in observable terms." },
      { id: "B2", text: "People know when they are expected to challenge, speak up, or escalate." },
      { id: "B3", text: "Leaders consistently reinforce the behaviours they expect from others." },
    ],
  },
  {
    key: "F",
    name: "Friction indicators",
    intro: "Whether the work is showing the visible signs of unclear operating conditions.",
    items: [
      { id: "F1", text: "Routine work often requires repeated clarification from a manager." },
      { id: "F2", text: "Decisions or exceptions are escalated more often than the work appears to require." },
      { id: "F3", text: "Work is regularly checked, corrected, or rescued by experienced individuals." },
    ],
  },
];

export const ORG_SIZES = ["1–20", "21–100", "101–500", "501–2,000", "2,000+"];
export const ROLE_BANDS = ["CEO / Managing Director", "COO / General Manager", "Operational executive", "Functional leader", "Business owner", "Other"];

export const BAND_STYLES = {
  "Clearer signal": { bar: "bg-ink", text: "text-ink" },
  "Mostly clear with local gaps": { bar: "bg-mute", text: "text-ink" },
  "Material ambiguity signal": { bar: "bg-terra", text: "text-terra" },
  "Strong ambiguity signal": { bar: "bg-terra", text: "text-terra" },
  "Not enough evidence": { bar: "bg-stone", text: "text-mute" },
};
